<script setup lang="ts">
import { type WithAttributes, toHtml, fw } from './attributes'

/* Will render slot only (no inherited attrs) if no label is provided, else it'll wrap the slot in a label */
defineOptions({ inheritAttrs: false })

// #region props
const props = defineProps<WithAttributes<{
  class: {
    layout?: 'layout-row-reverse'
  }
  disabled?: boolean
  required?: boolean
  label?: string
  for?: string
}>>()
// #endregion props
</script>

<template>
  <label
    v-if="props.label || $slots.label"
    v-bind="toHtml<'label'>(props)"
    :for="props.for"
    :class="[
      !props.class?.includes('layout-') && fw.layout.stack,
      props.class,
      $style.label,
    ]"
  >
    <span
      :class="[
        fw.font.captionEmphasized,
        fw.layout.row,
        $style.labelText
      ]"
      ui-nowrap
      ui-gap="8"
    >
      <slot name="label">
        {{ props.label }}
      </slot>
      <Icon
        v-if="required"
        icon="mdi:required"
      />
    </span>
    <slot />
  </label>
  <slot v-else />
</template>

<style module>
.label {
    position: relative;
  .labelText {
    position: absolute;
    bottom: calc(100% + 8px);
  }

  /* Badge placement */
  --badge-inset: -10px -10px auto auto;
}
@media (max-width: 767px) {
  .label {
    min-width: 0;
  }
  .label .labelText {
    max-width: 100%;
    white-space: normal;
    overflow-wrap: anywhere;
    flex-wrap: wrap;
    line-height: 1.2;
  }
}
</style>
